type AssertPropsType = <TProps extends {}, TPropNames extends keyof TProps>(
  propNames: TPropNames[] | TPropNames
) => (
  props: TProps
) => TProps & {[PropName in TPropNames]: NonNullable<TProps[PropName]>}

const assertProps: AssertPropsType = (_propNames) => (props) => props as any

export default assertProps
